module.exports = __webpack_public_path__ + "static/img/cars2-cover.e7fcae9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/cars2-cover.png
// module id = ED/a
// module chunks = 13